import {PieChart} from '@mui/x-charts/PieChart';
import PropTypes from "prop-types";
import BaseComponent from "../../../../lib/components/BaseComponent";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import ALink from "../../../../lib/components/Link/ALink";
import shortid from "shortid";
import CM from "../../../model/system/CM";
import React, {createRef} from "react";
import ReadCampaignTableList from "../../../model/service/campaign/dto/ReadCampaignTableList";
import Menu from "../../../../lib/components/menu/Menu";
import MenuItemGroup from "../../../../lib/components/menu/MenuItemGroup";
import Window from "../../../../lib/components/window/Window";
import {toast} from "react-toastify";
import ReadCampaignFunctionList from "../../../model/service/campaign/dto/ReadCampaignFunctionList";
import EntityDescribe from "../../../../lib/model/service/entity/dto/EntityDescribe";
import VariablesForm from "../variables/VariablesForm";
import EntityForm from "../entity/form/EntityForm";
import DialogBase from "../../../../lib/components/dialogs/DialogBase";
import InputText from "../inputFields/InputText";
import CreateVariant from "../../../model/service/campaign/dto/CreateVariant";
import CampaignService from "../../../model/service/campaign/CampaignService";
import ReadVariableInfos from "../../../model/service/campaign/dto/ReadVariableInfos";
import IsAnalyticsActivated from "../../../model/service/campaign/dto/IsAnalyticsActivated";
import CreateAnalyticsSite from "../../../model/service/campaign/dto/CreateAnalyticsSite";
import RemoveVariant from "../../../model/service/campaign/dto/RemoveVariant";
import GetAnalyticsLink from "../../../model/service/campaign/dto/GetAnalyticsLink";
import he from 'he';
import UstoreModuleService from "../../../../lib/model/campaign/modules/ustore/v002/service/UstoreModuleService";
import GetMailStatus from "../../../../lib/model/campaign/modules/ustore/v002/service/dto/GetMailStatus";
import T from "../../../model/system/text_translations/Translator";
import EmptyTableData from "../../../../lib/model/service/entity/dto/EmptyTableData";
import IsAnalyticsEnabled from "../../../model/service/campaign/dto/IsAnalyticsEnabled";
import Button from "../buttons/Button";
import {
  Add, Circle, Delete, Functions, InfoOutlined, PieChartOutline, ScheduleSend, StorageOutlined, TuneOutlined
} from "@mui/icons-material";
import MenuItem from "../menu/MenuItem";
import ConfirmationDialog from "../../../../lib/components/dialogs/ConfirmationDialog";
import {IconButton} from "@mui/material";
import InputDropDown from "../inputFields/dropdown/InputDropDown";
import MailingStepper from "../mailingWizard/MailingStepper";
import ReadMailTemplates from "../../../../lib/model/campaign/modules/ustore/v002/service/dto/ReadMailTemplates";
import BaseTab from "../tabbar/BaseTab";

// noinspection JSUnresolvedReference
class CampaignDashBoard extends BaseComponent {

  constructor(props) {
    super(props);
    this.mainPanel = CM.get().getPanel();
    this.sideBar = this.mainPanel.layoutRef.current.sideBarRef.current;
    this.campaignId = this.props.data.campaignId.value;
    this.campaignHref = '';
    this.state = {
      createVariantDialog: null, addNewVariablesMenu: null
    }
    this.entityFormRef = [];
    this.wizardBaseRef = createRef();
    this.wizardNavRef = createRef();
    this.analyticsDialogRef = createRef();
    this.clearMenuRequests();
  }

  componentDidMount() {
    this.createSideMenu();
  }

  private_createStatisticLabels(statisticElements) {
    let statisticsLegend = [];
    let total = 0;

    let createEntry = (entry) => (<div key={shortid()} className='flex justify-between gap-x-5'>
      <div className='flex whitespace-nowrap gap-2'>
        <Circle sx={{width: 12, stroke: entry.color, fill: entry.color}}/>
        {entry.label}
      </div>
      <div>{entry.value}</div>
    </div>);

    for (let entryIndex in statisticElements) {
      let entry = statisticElements[entryIndex];
      total += entry.value;
      statisticsLegend.push(createEntry(entry));
    }

    return statisticsLegend;
  }

  private_createStatisticElements() {
    let statisticElements = [];
    for (let propertyName in this.props.data.statistic) {
      let elementValue = this.props.data.statistic[propertyName];
      statisticElements.push({label: elementValue.label, value: elementValue.value, color: elementValue.color});
    }
    return statisticElements;
  }

  createAdditionalTableButtons(entityDef, table) {
    let additionalTableButtons = [];
    if (table.isTypoModuleUsed !== '' && table.isTypoModuleUsed !== false) {
      additionalTableButtons.push(
        <Button size='small' key={shortid()} ref={createRef()} uid='OMS' tooltip={T.label_omsOverview()}
                onClick={(e) => this.openOMS(e)}> OMS</Button>);
    }
    return additionalTableButtons;
  }

  createMailingButton(table, campaignId, mailGenerateRoute) {
    let mailingButton = null;
    if (table.isTypoModuleUsed !== '' && table.isTypoModuleUsed !== false && table.isTypoModuleUsed !== null) {
      mailingButton = <Button
        startIcon={<ScheduleSend/>}
        onClick={(e) => this.openMailingDialog(e, campaignId, table.name, mailGenerateRoute)}>
        Versand vorbereiten
      </Button>;
    }
    return mailingButton;
  }

  createSideMenu() {
    this.sideBar.clearMenu();
    if (!this.variablesMenu) {
      this.doAddVariableMenu();
    }
    if (!this.tablesMenu) {
      this.doAddTableMenu();
    } else {
      this.addElementsToMenu();
    }
    if (!this.analyticsMenu) {
      this.doAddAnalyticsMenu();
    }
    if (!this.functionMenu) {
      this.doAddFunctionMenu();
    }
  }

  clearMenuRequests() {
    this.doAddTableMenuRequestDone = false;
    this.doAddFunctionMenuRequestDone = false;
    this.doAddVariableMenuRequestDone = false;
    this.doAddAnalyticsMenuRequestDone = false;
    this.tablesMenu = null;
    this.variablesMenu = null;
    this.functionMenu = null;
    this.analyticsMenu = null;
  }

  addTableTabToTabLayout(table, campaignId) {
    let describeTable = new EntityDescribe([table.name]);
    describeTable.setProperties(CampaignService.createCampaignRedirectProperty(this.campaignId));
    let tabName = campaignId + ':' + table.name;

    if (!(tabName in this.mainPanel.horizontalTabBarRef.current.state.identifications)) {
      this.doDataFetch(describeTable, 'DoctrineEntityService', (response) => {
        if (response.success) {
          let entityDef = response.data.serviceDescription.entityDefs[0];
          let tableLabel = campaignId + ':' + entityDef.baseDef.description;

          let additionalTableButtons = this.createAdditionalTableButtons(entityDef, table, campaignId);
          let mailingButton = this.createMailingButton(table, campaignId, this.props.data.mailGenerateRoute);

          let entityFormRefKey = this.buildEntityFormRefKey(campaignId, table.name);
          this.entityFormRef[entityFormRefKey] = createRef();

          let tabId = this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={tableLabel}/>, <EntityForm
            ref={this.entityFormRef[entityFormRefKey]}
            isMainTable={table.isMainTable}
            tabId={tabName}
            campaignId={campaignId}
            entityDef={entityDef}
            tabMainContainer={this.mainPanel.horizontalTabBarRef.current}
            functionElements={mailingButton}
            additionalTableButtons={additionalTableButtons}
            mailGenerateRoute={this.props.mailGenerateRoute} />, tabName);

          this.mainPanel.horizontalTabBarRef.current.addTabListener({id: tabId, hook: (id) => {
              if (id === tabId) {
                this.createSideMenu();
              }
            }});
        } else {
          if (response.message !== undefined) {
            toast.error(response.message);
          } else {
            toast.error('Tabelleninhalt konnte nicht geladen werden!');
          }
        }
      });
    } else {
      this.mainPanel.horizontalTabBarRef.current.setActiveTab(this.mainPanel.horizontalTabBarRef.current.state.identifications[tabName]);
    }
  }

  buildEntityFormRefKey(campaignId, entityName) {
    return campaignId + '-' + entityName;
  }

  openMailingDialog(e, campaignId, entityName, mailGenerateRoute) {
    let readMailTemplates = new ReadMailTemplates(campaignId);
    readMailTemplates.setProperties(CampaignService.createCampaignRedirectProperty(campaignId));
    UstoreModuleService.doRequest(readMailTemplates, (response) => {
      let mailingStepperDialog = (<DialogBase fullWidth maxWidth='lg' title='Versand vorbereiten' open={true}>
        <MailingStepper campaignId={campaignId} entityName={entityName} configurations={response.data.data} mailGenerateRoute={mailGenerateRoute}/>
      </DialogBase>);
      CM.get().setMainDialog(mailingStepperDialog, (e) => CM.get().closeMainDialog(e));
    });
  }

  openOMS(e) {
    let self = this
    let tabId = this.campaignId + ':OMS';
    let entityDescribe = new EntityDescribe(['appl\\model\\entity\\OutputTable']);
    let dtoProps = CampaignService.createCampaignRedirectProperty(this.campaignId, 'oms');
    entityDescribe.setProperties(dtoProps);

    if (!(tabId in this.mainPanel.horizontalTabBarRef.current.state.identifications)) {
      CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), entityDescribe, (response) => {
        if (response.success) {
          this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={self.campaignId + ':OMS'}/>,
            <EntityForm isMainTable={false} tabId={'OMS'} campaignId={self.campaignId} entityDef={response.data.serviceDescription.entityDefs[0]} dtoProperties={dtoProps}
                        tabMainContainer={self.mainPanel.horizontalTabBarRef.current} additionalTableButtons={[
              <Button key={shortid()} uid='MAILING_INFO' onClick={(e) => this.displayMailingInfos(e)}
                      tooltip='Mailing-Infos'><InfoOutlined/></Button>]}/>, tabId);
        } else {
          toast.error(response.message);
        }
      });
    } else {
      this.mainPanel.horizontalTabBarRef.current.setActiveTab(this.mainPanel.horizontalTabBarRef.current.state.identifications[tabId]);
    }
  }

  displayMailingInfos(e) {
    let getMailStatus = new GetMailStatus(this.campaignId);
    getMailStatus.setProperties(CampaignService.createCampaignRedirectProperty(getMailStatus.getCampaignId()));
    CM.get().doJsonAjax(CM.get().getServiceUrl(UstoreModuleService.NAME), getMailStatus, (response) => {
      if (response.success) {
        let data = response.data.data;
        let dialog = <DialogBase title='Mailinginfos'>
          <Menu>
            <MenuItem className='gap-x-10 justify-between'>
              <h4 className='font-cn-inter-regular'>Offene Mailings</h4>
              <p className='rounded-full px-2 py-0.5 bg-cn-color-secondary'>{data.numOfOpenDocs}</p>
            </MenuItem>
            <MenuItem className='gap-x-10 justify-between'>
              <h4 className='font-cn-inter-regular'>Mailings am versenden</h4>
              <p className='rounded-full px-2 py-0.5 bg-cn-color-secondary'>{data.numOfInProgressDocs}</p>
            </MenuItem>
            <MenuItem className='gap-x-10 justify-between'>
              <h4 className='font-cn-inter-regular'>Erfolgreich versendete Mailings</h4>
              <p className='rounded-full px-2 py-0.5 bg-cn-color-secondary'>{data.numOfFinishedDocs}</p>
            </MenuItem>
            <MenuItem className='gap-x-10 justify-between'>
              <h4 className='font-cn-inter-regular'>Mailings mit Fehler</h4>
              <p className='rounded-full px-2 py-0.5 bg-cn-color-secondary'>{data.numOfErrorDocs}</p>
            </MenuItem>
            <MenuItem className='gap-x-10 justify-between'>
              <h4 className='font-cn-inter-regular'>Total Mailings</h4>
              <p className='rounded-full px-2 py-0.5 bg-cn-color-secondary'>{data.numOfTotalDocs}</p>
            </MenuItem>
          </Menu>
        </DialogBase>
        CM.get().setMainDialog(dialog);
      } else {
        let message = response.message != null ? response.message : T.genericErrorMessage();
        toast.error(message);
      }
    });

  }

  doAddTableMenu() {
    let self = this;
    let tableMenuHeader =
      <HorizontalLayout className='bg-cn-color-secondary text-cn-color-static-white p-4 cn-border-radius gap-x-3'>
        <StorageOutlined/>{T.label_tables()}
      </HorizontalLayout>;
    let campaignId = this.props.data.campaignId.value;

    this.doDataFetch(new ReadCampaignTableList(campaignId), 'campaign', (response) => {
      if (response.success) {
        let campaignTables = [];
        for (let table of response.data.campaignTables) {
          campaignTables.push(
            <MenuItem className='px-4 py-1.5 justify-between hover:bg-transparent ' key={table.name} option={table.name}>
              <div className='w-full hover:text-cn-color-secondary transition' onClick={(e) => self.addTableTabToTabLayout(
                table, campaignId)}>
                {table.label}
              </div>
              <IconButton size='small' onClick={(e) => this.emptyTableData(e, campaignId, table.name, table.label)}>
                <Delete className='hover:text-cn-color-static-red'/>
              </IconButton>
            </MenuItem>);
        }
        self.tablesMenu = <MenuItemGroup key={shortid()} header={tableMenuHeader}>
          {campaignTables}
        </MenuItemGroup>
      } else {
        if (response.message !== undefined) {
          toast.error(response.message);
        } else {
          toast.error('Tabellen konnten nicht ermittelt werden!');
        }
      }
      self.doAddTableMenuRequestDone = true;
      self.addElementsToMenu();
    });
  }

  doAddFunctionMenu() {
    let self = this;
    let functionsMenuGroupHeader =
      <HorizontalLayout className='bg-cn-color-secondary text-cn-color-static-white p-4 cn-border-radius gap-x-3 items-center mb-2'>
        <Functions/>{T.label_functions()}
      </HorizontalLayout>;
    let campaignId = this.props.data.campaignId.value;
    let functionList = [];

    this.doDataFetch(new ReadCampaignFunctionList(campaignId), 'campaign', (response) => {
      if (response.success) {
        for (let campaignFunction of response.data.functions.function) {
          functionList.push(
            <MenuItem className='px-4 py-1.5 justify-between hover:bg-transparent hover:text-cn-color-secondary transition' onClick={() => {
              window.open(self.getLinkOutOfATag() + campaignFunction['link'], '_blank');
            }} key={campaignFunction['link']} option={campaignFunction['link']}>{campaignFunction.label}</MenuItem>)
        }
        if (functionList.length > 0) {
          self.functionMenu = <MenuItemGroup key={shortid()} header={functionsMenuGroupHeader}>
            {functionList}
          </MenuItemGroup>
        }
      } else {
        toast.error('Die Funktionsliste konnte nicht ermittelt werden!');
      }
      self.doAddFunctionMenuRequestDone = true;
      self.addElementsToMenu();
    });
  }

  addElementsToMenu() {
    if (this.doAddTableMenuRequestDone && this.doAddVariableMenuRequestDone && this.doAddFunctionMenuRequestDone &&
      this.doAddAnalyticsMenuRequestDone) {
      this.sideBar.clearMenu();
      let doSetState = false;
      if (this.tablesMenu !== null) {
        this.sideBar.addMenu(this.tablesMenu);
        doSetState = true;
      }
      if (this.variablesMenu !== null) {
        this.sideBar.addMenu(this.variablesMenu);
        doSetState = true;
      }
      if (this.analyticsMenu !== null) {
        this.sideBar.addMenu(this.analyticsMenu);
        doSetState = true;
      }
      if (this.functionMenu !== null) {
        this.sideBar.addMenu(this.functionMenu);
        doSetState = true;
      }
      if (doSetState) {
        this.sideBar.setState(this.sideBar.state);
      }
    }
  }

  doAddVariableMenu() {
    let self = this;
    let variablesMenuHeader =
      <HorizontalLayout className='bg-cn-color-secondary text-cn-color-static-white items-center p-3 cn-border-radius gap-x-3 justify-between'>
        <TuneOutlined/>{T.label_variant()}
        <IconButton size='small' onClick={this.onNewVariablesClick}>
          <Add className='text-cn-color-static-white'/>
        </IconButton>
      </HorizontalLayout>;
    let campaignId = this.props.data.campaignId.value;
    let campaignVariables = [];
    this.doDataFetch(new ReadVariableInfos(campaignId), 'campaign', (response) => {
      if (response.success) {
        for (let variantIndex in response.data.variants) {
          let variantName = response.data.variants[variantIndex];

          let trash;
          if (variantName !== 'std') {
            trash = <IconButton
              size={'small'}
              onClick={(e) => this.removeVariant(e, variantName, campaignId)}>
              <Delete className='hover:text-cn-color-static-red'/>
            </IconButton>
          }
          // faha: Added this so users see Standard, but it is std in the background
          let variantTmpName = variantName === 'std' ? 'Standard' : variantName;
          campaignVariables.push(
            <MenuItem key={variantIndex} option={variantIndex} className='px-4 py-1.5 justify-between hover:bg-transparent'>
              <div className='w-full hover:text-cn-color-secondary transition' onClick={(e) => self.onVariableVariantClick(
                e, variantName, campaignId)}>
                {variantTmpName}
              </div>
              {trash}
            </MenuItem>)
        }
        self.variablesMenu = <MenuItemGroup key={shortid()} className='relative' header={variablesMenuHeader}>
          {campaignVariables}
        </MenuItemGroup>;
      } else {
        toast.error('Die Varianten konnten nicht ermittelt werden!');
      }
      self.doAddVariableMenuRequestDone = true;
      self.addElementsToMenu();
    });
  }

  removeVariant(e, variantName, campaignId) {
    let self = this;

    let deleteVariantDialog = <ConfirmationDialog
      isOpen={true}
      title='Variante löschen'
      confirmButtonColor='error'
      onCancelClick={(e) => CM.get().closeMainDialog(e)}
      onConfirmClick={(e) => {
        CM.get().doJsonAjax(CM.get().getServiceUrl(CampaignService.NAME),
          new RemoveVariant(campaignId, variantName, null), (response) => {
            if (response.success) {
              CM.get().closeMainDialog(e);
              toast.success('Variante [' + variantName + '] wurde erfolgreich gelöscht.');
              this.variablesMenu = null;
              self.createSideMenu(true);
              this.mainPanel.horizontalTabBarRef.current.removeTab(campaignId + ':' + variantName);
            } else {
              toast.error(response.message);
            }
          });
      }}>
      Möchten Sie Variante [{variantName}] löschen?
    </ConfirmationDialog>;

    CM.get().setMainDialog(deleteVariantDialog);
  }

  emptyTableData(e, campaignId, tableName, tableLabel) {
    let self = this;
    let doEmptyTableData = (e) => {
      CM.get().doJsonAjax(CM.get().getServiceUrl('DoctrineEntityService'), new EmptyTableData(campaignId, tableName),
        (response) => {
          if (response.success) {
            let entityFormRef = this.entityFormRef[self.buildEntityFormRefKey(campaignId, tableName)];
            if (entityFormRef && entityFormRef.current && entityFormRef.current.entityRef &&
              entityFormRef.current.entityRef.current) {
              this.entityFormRef[self.buildEntityFormRefKey(campaignId,
                tableName)].current.entityRef.current.doReadTable();
            }
            CM.get().closeMainDialog(e);
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
        });
    }
    let emptyTableDataDialog = <ConfirmationDialog
      title='Tabelleninhalt leeren'
      onCancelClick={e => CM.get().closeMainDialog(e)}
      onConfirmClick={doEmptyTableData}>
      möchtest du die ausgewählte Tabelle [{tableLabel}] leeren?'
    </ConfirmationDialog>

    CM.get().setMainDialog(emptyTableDataDialog);
  }

  getLinkOutOfATag() {
    let aHref = '';
    if (this.props.data.campaignLink !== undefined && this.props.data.campaignLink.value !== undefined) {
      let domParser = new DOMParser();
      let linkNode = domParser.parseFromString(this.props.data.campaignLink.value, 'text/xml');
      let aTag = linkNode.getElementsByTagName('a')[0];
      aHref = aTag.getAttribute('href');
    }
    return aHref;
  }

  onNewVariablesClick = () => {
    let variantName;
    let variantTemplate = '';

    let tempDialog = <DialogBase title='Neue Variante erstellen'>
      <VerticalLayout className='gap-4'>
        <InputText onChange={(e, id, value) => variantName = value} labelElement='Variante-Name'/>
        <InputDropDown
          labelElement='Varianten-Template'
          onChange={(e, id, data) => variantTemplate = data}
          defaultValue={'DE'}>
          <MenuItem value="DE">Deutsch</MenuItem>
          <MenuItem value="FR">Französisch</MenuItem>
          <MenuItem value="IT">Italienisch</MenuItem>
          <MenuItem value="EN">Englisch</MenuItem>
        </InputDropDown>
        <Button color='primary' onClick={(e) => {
          let dtoCreateVariant = new CreateVariant(this.campaignId, variantName, variantTemplate);
          CM.get().doJsonAjax(CM.get().getServiceUrl('Campaign'), dtoCreateVariant, (response) => {
            if (response.success) {
              toast.success('Variant wurde erfolgreich erstellt.');
              CM.get().closeMainDialog();
              this.variablesMenu = null;
              this.createSideMenu();
            } else {
              toast.error('Variant konnte nicht erstellt werden! ' + response.message);
            }
          });
        }}>{T.label_create()}</Button>
      </VerticalLayout>
    </DialogBase>;
    CM.get().setMainDialog(tempDialog, (e) => CM.get().closeMainDialog(e));
  }

  onVariableVariantClick(e, variantName, campaignId) {
    //let tabRef = createRef();

    // faha added this so users see standard, but it is std in the background
    let variantTmpName = variantName === 'std' ? 'Standard' : variantName;
    let tabId = campaignId + ':' + variantTmpName;

    if (!(tabId in this.mainPanel.horizontalTabBarRef.current.state.identifications)) {
      let tabIdNumber = this.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={tabId}/>,
        <VariablesForm id={tabId} variant={variantName} campaignId={campaignId} campaignHref={this.campaignHref}/>, tabId);

      this.mainPanel.horizontalTabBarRef.current.addTabListener({id: tabIdNumber, hook: (id) => {
          if (id === tabIdNumber) {
            this.createSideMenu();
          }
        }});
    } else {
      this.mainPanel.horizontalTabBarRef.current.setActiveTab(this.mainPanel.horizontalTabBarRef.current.state.identifications[tabId]);
    }
  }

  onTabClick(id, mode) {
    if (this.props.id === id) {
      this.createSideMenu();
    }
  }

  doAddAnalyticsMenu() {
    let self = this;
    let campaignId = this.props.data.campaignId.value;

    this.doDataFetch(new IsAnalyticsEnabled(campaignId), CampaignService.NAME, (response) => {
      if (response.success) {
        if (response.data.data) {
          this.isAnalyticsActivated(campaignId);
        } else {
          self.doAddAnalyticsMenuRequestDone = true;
          self.addElementsToMenu();
        }
      } else {
        self.doAddAnalyticsMenuRequestDone = true;
        self.addElementsToMenu();
        toast.error('Der Analyticsstatus konnte nicht abgefragt werden!');
      }
    });
  }

  isAnalyticsActivated(campaignId) {
    let self = this;
    this.doDataFetch(new IsAnalyticsActivated(campaignId), CampaignService.NAME, (response) => {
      if (response.success) {
        if (response.data.data) {
          this.prepareAnalyticsMenuWithAnalyticsLink(campaignId);
        } else {
          this.doAnalyticsDialog(campaignId);
          self.doAddAnalyticsMenuRequestDone = true;
          self.addElementsToMenu();
        }
      } else {
        self.doAddAnalyticsMenuRequestDone = true;
        self.addElementsToMenu();
        // toast.error('Analytics Fehler');
      }
    });
  }

  prepareAnalyticsMenuWithAnalyticsLink(campaignId) {
    let self = this;
    this.doDataFetch(new GetAnalyticsLink(campaignId), CampaignService.NAME, (analyticsResponse) => {
      if (analyticsResponse.success) {
        self.createAnalyticsMenu('Analytics', (e) => {
          if (analyticsResponse.data.loginUrl !== '') {
            window.open(analyticsResponse.data.loginUrl);
          } else {
            toast.warning('Analytics ist nicht aktiviert!')
          }
        });
      } else {
        toast.error(analyticsResponse.response.message);
      }
      self.doAddAnalyticsMenuRequestDone = true;
      self.addElementsToMenu();
    });
  }

  doAnalyticsDialog(campaignId) {
    let self = this;

    let doCreateAnalyticsSite = (e) => {
      self.doDataFetch(new CreateAnalyticsSite(campaignId), CampaignService.NAME, (response) => {
        if (response.success) {
          toast.success('Analytics wurden aktiviert');
          CM.get().closeMainDialog(e);
          self.createSideMenu(true);
        } else {
          self.doAddAnalyticsMenuRequestDone = true;
          self.addElementsToMenu();
          toast.error(response.message);
        }
        CM.get().closeMainDialog(e);
      }, true);
    };

    this.createAnalyticsMenu(T.label_activate_analytics(), (e) => {
      let activateAnalyticsDialog = <ConfirmationDialog
        title='Analytics'
        onConfirmClick={doCreateAnalyticsSite}
        onCancelClick={e => CM.get().closeMainDialog(e)}>
        Möchten Sie Analytics aktivieren?
      </ConfirmationDialog>
      CM.get().setMainDialog(activateAnalyticsDialog);
    });
  }

  createAnalyticsMenu(title, callBack) {
    let analyticsMenuHeader =
      <HorizontalLayout className='bg-cn-color-secondary text-cn-color-static-white p-4 cn-border-radius gap-x-3 cursor-pointer'
                        onClick={(e) => callBack(e)}>
        <PieChartOutline/>{title}
      </HorizontalLayout>;
    this.analyticsMenu = <MenuItemGroup key={shortid()} className="hover:bg-transparent" header={analyticsMenuHeader}/>;
  }

  render() {
    let statisticElements = this.private_createStatisticElements();
    let statisticsLegend = this.private_createStatisticLabels(statisticElements);
    this.campaignHref = this.getLinkOutOfATag();
    return <Window className='CNINFO-CampaignDashBoard'>
      <div className='grid grid-cols-1 lg:grid-cols-3 gap-10 p-0 md:p-10'>
        <div className='col-span-full md:col-span-1 border-r-0 xl:border-r'>
          <h2>{T.label_activities()}</h2>
          <HorizontalLayout className='flex-wrap items-center' widthFit>
            <div>
              <PieChart
                width={250}
                height={200}
                slotProps={{legend: {hidden: true}}}
                series={[{
                  data: statisticElements, innerRadius: 26, paddingAngle: 4, cornerRadius: 4, startAngle: -45,
                }]}/>
            </div>
            <div>
              {statisticsLegend}
            </div>
          </HorizontalLayout>
        </div>
        <div className='col-span-full md:col-span-2 xl:col-span-1'>
          <h2 className='mb-3'>{T.label_overview()}</h2>
          <div className='grid grid-cols-2 w-full gap-y-2'>
            <div className='col-span-1 cn-font-paragraph'>campaign-ID:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.campaignId.value}</div>
            <div className='col-span-1 cn-font-paragraph'>campaign-Name:</div>
            <div className='col-span-1 cn-font-paragraph'>{he.decode(this.props.data.name.value)}</div>
            <div className='col-span-1 cn-font-paragraph'>campaign-Beschreibung:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.description.value}</div>
            <div className='col-span-1 cn-font-paragraph'>campaign-Status:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.status.value}</div>
            <div className='col-span-1 cn-font-paragraph'>Erstellt von:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.createdBy.value}</div>
            <div className='col-span-1 cn-font-paragraph'>Erstellt am:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.createdDateTime.value}</div>
            <div className='col-span-1 cn-font-paragraph'>Event-Start am:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.eventStartDateTime.value}</div>
            <div className='col-span-1 cn-font-paragraph'>Event-Ende am:</div>
            <div className='col-span-1 cn-font-paragraph'>{this.props.data.eventEndDateTime.value}</div>
            <div className='col-span-1 cn-font-paragraph'>Link:</div>
            <div className='col-span-1 cn-font-paragraph relative top-[-10px]'>
              <ALink title={this.campaignHref} href={this.campaignHref} target='_blank'/>
            </div>
          </div>
        </div>
      </div>
    </Window>;
  }
}

CampaignDashBoard.propTypes = {
  parent: PropTypes.object, id: PropTypes.string, data: PropTypes.object
}
export default CampaignDashBoard
